module.exports = __webpack_public_path__ + "img/gloria@1x.9b83528c.jpg";